import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const shellStyle = {
    borderRadius: '18px',
    boxShadow: '0 25px 50px rgba(15, 23, 42, 0.15)',
    background: '#fff',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%'
};
const headerStyle = {
    padding: '16px',
    fontWeight: 600,
    background: 'linear-gradient(135deg, #2563eb, #7c3aed)',
    color: '#fff',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
};
const closeButtonStyle = {
    background: 'rgba(255, 255, 255, 0.2)', // 背景色を少し入れて視認性を高める
    border: 'none',
    color: '#fff',
    cursor: 'pointer',
    width: '28px', // サイズを固定
    height: '28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    fontSize: '18px',
    lineHeight: 1,
    padding: 0,
    marginLeft: '8px' // タイトルとの間隔
};
export const WidgetShell = ({ title = 'AI チャット', className, style, onClose, children }) => {
    // React要素（JSX要素）を検出して文字列に変換
    let titleText;
    if (typeof title === 'string') {
        titleText = title;
    }
    else if (title && typeof title === 'object' && '$$typeof' in title) {
        // React要素の場合は警告を出してデフォルト値にする
        console.error('⚠️ React element detected in WidgetShell title!', title);
        titleText = 'AI チャット';
    }
    else {
        titleText = String(title ?? 'AI チャット');
    }
    return (_jsxs("div", { className: className, style: { ...shellStyle, ...style }, children: [_jsxs("header", { style: headerStyle, children: [_jsx("span", { children: titleText }), onClose && (_jsx("button", { style: closeButtonStyle, onClick: onClose, "aria-label": "\u9589\u3058\u308B", children: "\u00D7" }))] }), _jsx("div", { style: { flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }, children: children })] }));
};
